// Field messages for the S-03 / S-04 issue codes (API.md §7.3, §7.5, §7.9). UserFlows owns the copy it gives
// ("Clinic ID already taken", the C-13a account message); the rest are task 03's wording.
export const FIELD_MESSAGES: Record<string, string> = {
  required: 'Required.',
  name_length: 'Enter a name (up to 120 characters).',
  slug_invalid: 'Use 3–40 lowercase letters, numbers and hyphens, starting and ending with a letter or number.',
  slug_reserved: 'This Clinic ID is reserved. Choose another.',
  slug_taken: 'Clinic ID already taken',
  timezone_invalid: 'Choose a time zone from the list.',
  timezone_not_whole_hour: 'Choose a time zone with a whole-hour UTC offset.',
  email_invalid: 'Enter a valid email address.',
  account_not_addable: "This email belongs to an account that can't be added here",
  base_url_invalid:
    'Use https:// with a private IP address (10.x, 172.16–31.x, 192.168.x) or a .internal host, an optional port and no path.',
  api_key_invalid: 'The API key is 20–200 printable characters.',
  api_key_required: 'Enter the API key.',
}

export const messageFor = (code: string): string => FIELD_MESSAGES[code] ?? 'Check this field.'

/** A basic email shape check for quick feedback; the server decides (API.md §6.19). */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** API.md §7.9: 20–200 printable ASCII characters. */
export const API_KEY_RE = /^[\x20-\x7E]{20,200}$/
